class SectionImgtop{
    constructor(el){
        this.DOM = el;
        console.log("section-imgtop", this.DOM)
    }
    static bind(){
        const elements = document.querySelectorAll('.section-imgtop')
        elements.forEach(el => new SectionImgtop(el))
    }
}
SectionImgtop.bind()
        